// Typed `t` for the 'training' namespace: (key, default, interpolation) → string.
// react-i18next's TFunction widens to `string | object` when options are passed,
// which JSX children reject; every learning component uses this instead.
import { useTranslation } from 'react-i18next';

export type TFn = (key: string, defaultValue: string, opts?: Record<string, unknown>) => string;

export function useT(): TFn {
  const { t } = useTranslation(['training']);
  return t as unknown as TFn;
}
